// Domain Configuration for Vikas Fund
// Update this file when deploying to different environments

// Development Environment
//const DEV_BASE_URL = "http://localhost:5000";
const DEV_BASE_URL = "https://funds.affluentix.com";

// Production Environment
const PROD_BASE_URL = "https://funds.affluentix.com";

// Determine which URL to use based on environment
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// Export the base URL
export const Base_Url = isProduction ? PROD_BASE_URL : DEV_BASE_URL;

// API endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: `${Base_Url}/api/auth/login`,
  ADMIN_LOGIN: `${Base_Url}/api/auth/admin-login`,
  REGISTER: `${Base_Url}/api/auth/register`,
  
  // User endpoints
  USERS: `${Base_Url}/api/admin/users`,
  USER_PROFILE: `${Base_Url}/api/user/profile`,
  
  // Application endpoints
  APPLICATIONS: `${Base_Url}/api/applications`,
  ADMIN_APPLICATIONS: `${Base_Url}/api/admin/applications`,
  
  // Payment endpoints
  PAYMENTS: `${Base_Url}/api/payments`,
  ADMIN_PAYMENTS: `${Base_Url}/api/admin/payments`,
  
  // Dashboard endpoints
  DASHBOARD_STATS: `${Base_Url}/api/admin/dashboard-stats`,
  
  // Export endpoints
  EXPORT_APPLICATIONS: `${Base_Url}/api/admin/export-applications`,
  EXPORT_APPLICATIONS_PDF: `${Base_Url}/api/admin/export-applications-pdf`,
  EXPORT_APPLICANTS_WITHOUT_PAYMENTS: `${Base_Url}/api/admin/export-applicants-without-payments`,
  
  // Payment reports
  APPLICANTS_WITHOUT_PAYMENTS: `${Base_Url}/api/admin/applicants-without-payments`,
  
  // File upload
  UPLOAD: `${Base_Url}/api/upload`,
  
  // Success stories
  SUCCESS_STORIES: `${Base_Url}/api/success-stories`,
  
  // Funding options
  FUNDING_OPTIONS: `${Base_Url}/api/funding-options`,
  
  // Masters
  COUNTRIES: `${Base_Url}/api/countries`,
  STATES: `${Base_Url}/api/states`,
  CITIES: `${Base_Url}/api/cities`,
  BUSINESS_CATEGORIES: `${Base_Url}/api/business-categories`,
  
  // Application periods
  APPLICATION_PERIODS: `${Base_Url}/api/application-periods`,
  
  // Funding results
  FUNDING_RESULTS: `${Base_Url}/api/funding-results`,
  
  // Settings
  SETTINGS: `${Base_Url}/api/settings`,
};

// Environment info
export const ENV_INFO = {
  isDevelopment,
  isProduction,
  environment: process.env.NODE_ENV || 'development',
  baseUrl: Base_Url
};

// Console log for debugging
if (isDevelopment) {
  console.log('🔧 Development Mode - Using:', Base_Url);
} else {
  console.log('🚀 Production Mode - Using:', Base_Url);
} 